import { render, staticRenderFns } from "./Error_tba.vue?vue&type=template&id=5490fd0b&"
import script from "./Error_tba.vue?vue&type=script&lang=js&"
export * from "./Error_tba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports